export default (that) => [
  {
    text: that.$l('menu_text_detail') || '查看详情',
    icon: 'el-icon-view',
    menuType: 'detail',
  },
  {
    text: that.$l('menu_text_review') || '审核',
    icon: 'el-icon-s-check',
    menuType: 'review',
    allow: 'A',
    divided: true,
    disabled: ({ amzFlipOrderStatus }) =>
      amzFlipOrderStatus === 'S' ||
      amzFlipOrderStatus === 'P' ||
      amzFlipOrderStatus === 'D',
  },
  {
    text: that.$l('menu_text_purchase') || '提交采购',
    icon: 'el-icon-sell',
    menuType: 'purchase',
    divided: true,
    allow: 'S',
    disabled: ({ amzFlipOrderStatus }) =>
      amzFlipOrderStatus === 'S' ||
      amzFlipOrderStatus === 'P' ||
      amzFlipOrderStatus === 'D',
  },
  {
    text: that.$l('menu_text_cancelPurchase') || '取消采购',
    icon: 'el-icon-sold-out',
    menuType: 'cancel-purchase',
    allow: 'B',
    disabled: ({ amzFlipOrderStatus }) => amzFlipOrderStatus !== 'S',
  },
]
